import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import Screen from "models/screen"

export interface AdminScreenSliceState {
    screens: Screen[],
}

export const initialState: AdminScreenSliceState = {
    screens: [],
}

const adminScreenSlice = createSlice({
    name: 'admin-screens',
    initialState,
    reducers: {
        setScreens(state, { payload }: PayloadAction<Screen[]>) {
            state.screens = payload
        },
    }
})

export default adminScreenSlice.reducer

export const {
    setScreens,
} = adminScreenSlice.actions
